import * as firebase from 'firebase/app';
import 'firebase/analytics'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/functions'
import 'firebase/messaging'
import 'firebase/storage'

import { browserHasPush } from '@/util'

firebase.initializeApp({
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
})

const plugins = {}

// analytics
firebase.analytics()

// database
const db = firebase.firestore()

db.enablePersistence()
  .then(() => console.log('Persistence enabled'))
  // do not send to bugsnag
  .catch(() => console.log('Error enabling offline persistence'))

plugins.db = db

// functions
export const functions = {
  addPaymentMethod: firebase.functions().httpsCallable('addPaymentMethod'),
  addSubscription: firebase.functions().httpsCallable('addSubscription'),
  cancelSubscription: firebase.functions().httpsCallable('cancelSubscription'),
  getSubscription: firebase.functions().httpsCallable('getSubscription'),
  resubscribe: firebase.functions().httpsCallable('resubscribe'),
  setEncryptionKey: firebase.functions().httpsCallable('setEncryptionKey'),
}

// messaging
let messaging
if (browserHasPush()) {
  messaging = firebase.messaging()
  messaging.usePublicVapidKey(process.env.VUE_APP_FIREBASE_VAPID_KEY)
}

plugins.messaging = messaging

// storage
plugins.storage = firebase.storage()

export default firebase

export { plugins }
